import type { ReactNode } from "react";
import clsx from "clsx";
import { Button } from "@/components/ui/Button";

export interface TimesheetDetailFooterAction {
  id: string;
  label: string;
  onClick: () => void;
  variant?: "primary" | "secondary" | "ghost";
  disabled?: boolean;
  hidden?: boolean;
}

export function TimesheetDetailFooter({
  onClose,
  nwAtContact,
  actions,
  iconActions,
}: {
  onClose: () => void;
  nwAtContact?: { checked: boolean; onChange: (checked: boolean) => void };
  actions: TimesheetDetailFooterAction[];
  /** Icon-Buttons (z. B. Projektübersicht / Ordner), rechts neben den Text-Aktionen. */
  iconActions?: ReactNode;
}) {
  const visible = actions.filter((a) => !a.hidden);

  return (
    <footer className="shrink-0 border-t border-separator bg-card-elevated">
      <div className="flex flex-col gap-2 px-4 py-3 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex flex-wrap items-center gap-2">
          <Button type="button" size="sm" variant="ghost" onClick={onClose}>
            Schließen
          </Button>
          {nwAtContact ? (
            <label
              className={clsx(
                "flex cursor-pointer items-center gap-2 rounded-lg px-2.5 py-1.5 text-sm text-label",
                "ring-1 ring-inset ring-separator/80 hover:bg-fill-tertiary",
              )}
            >
              <input
                type="checkbox"
                className="h-4 w-4 rounded border-separator"
                checked={nwAtContact.checked}
                onChange={(e) => nwAtContact.onChange(e.target.checked)}
              />
              NW bei AP
            </label>
          ) : null}
        </div>

        {visible.length > 0 || iconActions ? (
          <div
            className="flex flex-wrap items-center gap-1.5 sm:justify-end"
            role="toolbar"
            aria-label="Aktionen"
          >
            {visible.map((action) => (
              <Button
                key={action.id}
                type="button"
                size="sm"
                variant={action.variant ?? "secondary"}
                disabled={action.disabled}
                onClick={action.onClick}
              >
                {action.label}
              </Button>
            ))}
            {iconActions}
          </div>
        ) : null}
      </div>
    </footer>
  );
}
